import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./user-form.css";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useDispatch, useSelector } from "react-redux";
import {
  populateStateWithUserDetails,
  updateLeadId,
} from "../../features/userDetailsSlice";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NewLoader from "../../components/reusable/NewLoader";

const UserDetailsPage = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { register, handleSubmit } = useForm();
  const [showLoader, setShowLoader] = useState(false);
  const dispatch = useDispatch();
  const { phoneNumber } = useSelector((state) => state.userDetails);

  const signUpAction = async (data) => {
    try {
      const postData = JSON.stringify({
        f_name: data.userFirstName,
        l_name: data.userLastName,
        email: data.userEmail,
        mobile: phoneNumber.slice(-10),
      });
      // request does not require authorization for sign up
      const response = await axios({
        url: `${process.env.REACT_APP_API_ENDPOINT}/mobile/signup`,
        method: "post",
        maxBodyLength: Infinity,
        headers: { "Content-Type": "application/json" },
        params: {},
        data: postData,
      });
      // handle response
      // console.log(response?.data);
      if (response?.data?.result?.success) {
        let leadId = response?.data?.result?.lead_id;
        dispatch(updateLeadId({ leadId: leadId }));
        toast.success("Registered successfully!", 3000);
        setShowLoader(false)
      }
      if (response?.data?.result?.message) {
        setShowLoader(false)
        toast.error(`${response.data.result.message}`, 5000);
      }
    } catch (error) {
      setShowLoader(false)
      // console.log(error);
      alert("couldn't sign up, something wrong happened!");
    }
  };

  const onSubmit = (data) => {
    // console.table(data);
    setShowLoader(true)
    setIsSubmitted(true);
    dispatch(
      populateStateWithUserDetails({
        fullName: `${data.userFirstName} ${data.userLastName}`,
        phoneNumber: phoneNumber,
        emailAddress: `${data.userEmail}`,
      })
    );

    signUpAction(data);
  };

  return (
    <div className="user-form">
      <div className="user-form__header">
        <p>Begin your journey</p>
        <h1>Enter your details</h1>
      </div>
      <form className="user-form__form-block" onSubmit={handleSubmit(onSubmit)}>
        <div className="user-form__input-wrapper">
          <label htmlFor="first name">First Name *</label>
          <input
            className="user-form__input--text"
            name="first name"
            type="text"
            required
            {...register("userFirstName")}
          />
        </div>
        <div className="user-form__input-wrapper">
          <label htmlFor="last name">Last Name *</label>
          <input
            className="user-form__input--text"
            name="last name"
            type="text"
            required
            {...register("userLastName")}
          />
        </div>
        <div className="user-form__input-wrapper">
          <label htmlFor="email">Email *</label>
          <input
            className="user-form__input--text user-form__input--email"
            name="email"
            type="email"
            required
            {...register("userEmail")}
          />
        </div>
        <div className="user-form__input-wrapper">
          {/* <input
            className={`${
              isSubmitted
                ? "user-form__input--submit--success"
                : "user-form__input--submit"
            }`}
            value={`Submit ${!showLoader && <NewLoader/>}`}
            type="submit"
          /> */}
          <button
          // onClick={() => setShowLoader(true)}
            type="submit"
            className={
              isSubmitted
                ? "user-form__input--submit--success"
                : "user-form__input--submit"
            }
          >
            {showLoader ? <NewLoader /> : "Submit"}
          </button>
        </div>
      </form>
      <div className="navigation-btn__group">
        <Link
          className="navigation-link-btn"
          to={isSubmitted ? `/services-for` : `/user-details`}
        >
          <Button
            color="primary"
            variant="outlined"
            className="navigation__btn"
            endIcon={<NavigateNextIcon />}
          >
            Next
          </Button>
        </Link>
      </div>
      <ToastContainer />
    </div>
  );
};

export default UserDetailsPage;
